module.exports = __webpack_public_path__ + "img/location-pin.3f4ea27e.svg";